import AsyncLoader from 'component/AsyncLoader';

export const AddRecord =  AsyncLoader(() => import('./AddRecord'));
export const SignRecord =  AsyncLoader(() => import('./SignRecord'));
export const RecordDetail =  AsyncLoader(() => import('./RecordDetail'));
export const TemporaryLogin =  AsyncLoader(() => import('./TemporaryLogin'));
export const TemporaryFailLog =  AsyncLoader(() => import('./TemporaryFailLog'));